import { render } from "./UserPasswordDialog.vue?vue&type=template&id=49fd978f&scoped=true"
import script from "./UserPasswordDialog.vue?vue&type=script&lang=js"
export * from "./UserPasswordDialog.vue?vue&type=script&lang=js"

import "./UserPasswordDialog.vue?vue&type=style&index=0&id=49fd978f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fd978f"]])

export default __exports__